import React from 'react';
import { observer, inject } from 'mobx-react';
import { AvForm } from 'availity-mobx-reactstrap-validation';
import { validatePrice } from 'js/services/Regex';
import StepStatus from 'js/components/core/SteppedPage/StepStatus';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import TitleInput from './TitleInput';
import MoneyInput from './MoneyInput';
import QtyInput from './QtyInput';
import ImageUploader from "js/components/core/ImageUploader";
import StepPage from '../StepPage';

export default inject('page')(
  observer(({ page }) => {
    const image = page.primary_image;
    const fileUpload = React.createRef();

    return (
      <StepPage page={page} current={1}>
        <h5>Add item image</h5>

        <ImageUploader style={{ textAlign: 'center', padding: '50px 0' }}
          className="file-uploader tw-bg-[url('/images/new-upload.png')]"
          image={image} setError={page.setError} onUpload={page.onUpload} height="247px"
          innerRef={fileUpload} id="fileUpload">
        </ImageUploader>

        <span className="clearfix" style={{ clear: 'both' }}>&nbsp;</span>

        <AvForm onValidSubmit={page.nextDetail}>
          <span className="tw-font-medium">Item name</span><br />
          <TitleInput name="title" value={page.title} onChange={page.setTitle} required />

          <div className="tw-flex tw-gap-2">
            <div>
              <span className="tw-font-medium">Price</span><br />
              <MoneyInput
                name="price"
                type="number"
                value={page.price}
                onChange={page.setPrice}
                validate={validatePrice}
                required
              />
            </div>

            <div>
              <span className="tw-font-medium">Quantity</span><br />
              <QtyInput
                name="quantity"
                type="number"
                value={page.quantity}
                onChange={page.setQuantity}
                required
              />
            </div>
          </div>

          <ContinueButton delay={0} onClick={page.nextStep} flat={false} disabled={!page.title.length || !page.price.length || !page.quantity.length} />

          <StepStatus />
        </AvForm>
      </StepPage>
    );
  }),
);
